!function ( doc, win) {
        var  defaults = {
                baseFontSize: 50,
                maxWidth: 750,
                minWidth: 190
            },
            conf = {};
        for (var key in defaults) {
            if (defaults.hasOwnProperty(key)) {
                conf[key] = defaults[key];
            }
        }

        var lastWidth, deviceWidth;

        /**
         * 重新调整rem的大小
         */
        function resizeRem() {
            var curWidth = 0;
            if (!deviceWidth && window.aji && window.aji.getDeviceWidth) {
                deviceWidth = window.aji.getDeviceWidth();
            }
            if (deviceWidth) {
                curWidth = deviceWidth / window.devicePixelRatio;
            } else {
                curWidth = Math.min(screen.availWidth, doc.documentElement.clientWidth);
            }

            if (!curWidth || (curWidth == lastWidth)) {
                return;
            }
            var HtmlSize = doc.querySelector('html').style
            if (curWidth > conf.maxWidth) {
                HtmlSize.fontSize = conf.baseFontSize + 'px';
            } else if (curWidth < conf.minWidth) {
                HtmlSize.fontSize = (conf.minWidth / conf.maxWidth) * conf.baseFontSize+'px'
            } else {
                HtmlSize.fontSize = (curWidth / conf.maxWidth) * conf.baseFontSize +'px'
            }
            lastWidth = curWidth;
        }
        resizeRem();
        win.addEventListener('resize',resizeRem);
}( document, window);


// WEBPACK FOOTER //
// ./src/plugins/mobile.js